import { render } from "./GlSvgIcon.vue?vue&type=template&id=a0b16fc8"
import script from "./GlSvgIcon.vue?vue&type=script&lang=js"
export * from "./GlSvgIcon.vue?vue&type=script&lang=js"

import "./GlSvgIcon.vue?vue&type=style&index=0&id=a0b16fc8&lang=scss"
script.render = render

export default script